"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isString_1 = __importDefault(require("lodash/isString"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var toUpper_1 = __importDefault(require("lodash/toUpper"));
var StringUtil = /** @class */ (function () {
    function StringUtil() {
    }
    StringUtil.isString = function (stringOrNumber) {
        return isString_1.default(stringOrNumber);
    };
    StringUtil.isEmpty = function (value) {
        if (isString_1.default(value)) {
            return isEmpty_1.default(value);
        }
        else if (value === undefined) {
            return true;
        }
        return false;
    };
    StringUtil.isNotEmpty = function (value) {
        return !isEmpty_1.default(value);
    };
    StringUtil.isAllEmpty = function (values) {
        var e_1, _a;
        if (Array.isArray(values)) {
            try {
                for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                    var value = values_1_1.value;
                    if (!isEmpty_1.default(value)) {
                        return false;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        }
        else if (values === undefined) {
            return true;
        }
        return false;
    };
    /**
     * Whitespaces return empty
     * @param value
     * @returns {boolean}
     */
    StringUtil.isBlank = function (value) {
        if (isString_1.default(value)) {
            return isEmpty_1.default(value.trim());
        }
        return StringUtil.isEmpty(value);
    };
    StringUtil.isAllBlank = function (values) {
        var e_2, _a;
        if (Array.isArray(values)) {
            try {
                for (var values_2 = __values(values), values_2_1 = values_2.next(); !values_2_1.done; values_2_1 = values_2.next()) {
                    var value = values_2_1.value;
                    if (!StringUtil.isBlank(value)) {
                        return false;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (values_2_1 && !values_2_1.done && (_a = values_2.return)) _a.call(values_2);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return true;
        }
        else if (values === undefined) {
            return true;
        }
        return false;
    };
    StringUtil.isNoneBlank = function (values) {
        var e_3, _a;
        if (Array.isArray(values)) {
            try {
                for (var values_3 = __values(values), values_3_1 = values_3.next(); !values_3_1.done; values_3_1 = values_3.next()) {
                    var value = values_3_1.value;
                    if (StringUtil.isBlank(value)) {
                        return false;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (values_3_1 && !values_3_1.done && (_a = values_3.return)) _a.call(values_3);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return true;
        }
        return !StringUtil.isBlank(values);
    };
    StringUtil.toUpper = function (value) {
        return toUpper_1.default(value);
    };
    /**
     * Count multi-bytes characters
     * @param value
     */
    StringUtil.characterCount = function (value) {
        if (value === void 0) { value = ''; }
        return Array.from(value).length;
    };
    StringUtil.subCharacter = function (value, start, length) {
        if (value === void 0) { value = ''; }
        if (start === void 0) { start = 0; }
        var chars = Array.from(value);
        return chars.slice(start, start + length).join('');
    };
    return StringUtil;
}());
exports.default = StringUtil;
//# sourceMappingURL=StringUtil.js.map